import { fetchChallengeGroup } from '@actions/challengeGroups';
import { RootState } from '@reducers/index';
import {
    getChallengeGroup,
    getChallengeGroupsFetchError,
    getChallengeGroupsIsFetching,
} from '@selectors/challengeGroups';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const useFetchChallengeGroup = (id: number) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchChallengeGroup(id));
    }, [dispatch, id]);

    const challengeGroup = useSelector((state: RootState) => getChallengeGroup(state, id));
    const isFetching = useSelector(getChallengeGroupsIsFetching);
    const fetchError = useSelector(getChallengeGroupsFetchError);

    return { challengeGroup, isFetching, fetchError };
};

export default useFetchChallengeGroup;
